import React, { useEffect, useState } from 'react';

// ==================== BOTÓN FLOTANTE DE WHATSAPP ====================
// Abre un chat de WhatsApp con un mensaje predefinido.
// - En escritorio: botón cómodo con etiqueta al pasar el ratón.
// - En móvil: más pequeño y discreto.
// - Se oculta automáticamente cuando hay un modal abierto (proyecto, producto,
//   cookies, etc.), para no quedar por encima del contenido en pantallas pequeñas.
const WHATSAPP_NUMBER = '34650441396';
const WHATSAPP_MESSAGE = 'Hola, me gustaría pedir información para una reforma o servicio.';

export default function WhatsAppButton() {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
  const [modalAbierto, setModalAbierto] = useState(false);

  useEffect(() => {
    const comprobarModal = () => {
      setModalAbierto(!!document.querySelector('[aria-modal="true"]'));
    };
    comprobarModal();
    // Observa el DOM para detectar cuándo se abre o cierra cualquier modal
    const observer = new MutationObserver(comprobarModal);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  if (modalAbierto) return null;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-40 group flex items-center gap-3"
    >
      {/* Etiqueta visible al pasar el ratón (solo escritorio) */}
      <span className="hidden md:block opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 bg-white text-gray-800 text-sm font-semibold px-4 py-2 rounded-full shadow-lg border border-gray-100 whitespace-nowrap">
        ¿Hablamos por WhatsApp?
      </span>

      <span className="relative flex h-12 w-12 sm:h-14 sm:w-14">
        {/* Halo animado sutil (solo escritorio, para no distraer en móvil) */}
        <span className="hidden sm:inline-flex absolute h-full w-full rounded-full bg-green-500 opacity-30 animate-ping [animation-duration:3s]"></span>
        {/* Botón */}
        <span className="relative inline-flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center rounded-full bg-gradient-to-br from-green-500 to-green-600 shadow-lg shadow-green-600/30 group-hover:scale-110 transition-transform duration-300 ring-1 ring-black/5">
          {/* Logo oficial de WhatsApp en SVG */}
          <svg viewBox="0 0 32 32" className="h-6 w-6 sm:h-7 sm:w-7 fill-white" aria-hidden="true">
            <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.6 4.463 1.732 6.404L3.2 28.8l6.567-1.72a12.73 12.73 0 0 0 6.237 1.588h.005c7.06 0 12.79-5.74 12.79-12.8 0-3.42-1.33-6.633-3.748-9.05a12.71 12.71 0 0 0-9.047-3.618zm0 23.31h-.004a10.6 10.6 0 0 1-5.4-1.48l-.388-.23-3.898 1.021 1.04-3.8-.253-.39a10.56 10.56 0 0 1-1.622-5.63c0-5.86 4.767-10.63 10.63-10.63 2.84 0 5.508 1.107 7.514 3.116a10.56 10.56 0 0 1 3.11 7.52c0 5.86-4.768 10.628-10.628 10.628zm5.83-7.96c-.32-.16-1.888-.932-2.18-1.038-.293-.107-.506-.16-.72.16-.213.32-.826 1.038-1.013 1.252-.186.213-.373.24-.692.08-.32-.16-1.35-.497-2.57-1.586-.95-.847-1.59-1.894-1.777-2.214-.187-.32-.02-.493.14-.652.144-.143.32-.373.48-.56.16-.187.213-.32.32-.534.107-.213.054-.4-.026-.56-.08-.16-.72-1.734-.986-2.374-.26-.623-.523-.54-.72-.55l-.612-.01c-.214 0-.56.08-.854.4-.293.32-1.12 1.093-1.12 2.667s1.146 3.093 1.306 3.307c.16.213 2.256 3.443 5.464 4.828.764.33 1.36.527 1.824.674.767.244 1.464.21 2.016.127.615-.092 1.888-.772 2.155-1.518.266-.746.266-1.386.186-1.519-.08-.133-.293-.213-.613-.373z" />
          </svg>
        </span>
      </span>
    </a>
  );
}
